import { UploadIcon } from "lucide-react"
import { TabsComponent } from "src/components/shared/TabsComponent"
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from "src/components/ui/breadcrumb"
import { MarketingAgentFormComponent } from "./MarketingAgentFormComponent"

export const MarketingAgentPageComponent = () => {
  return (
    <div className="mt-5 px-2">
        <div className='flex items-center'>
            <Breadcrumb>
                <BreadcrumbList>
                    <BreadcrumbItem>
                        <BreadcrumbLink href="/">Inicio</BreadcrumbLink>
                    </BreadcrumbItem>
                    <BreadcrumbSeparator />
                    <BreadcrumbItem>
                        <BreadcrumbPage>Agente de Marketing</BreadcrumbPage>
                    </BreadcrumbItem>
                </BreadcrumbList>
            </Breadcrumb>
        </div>
        <TabsComponent heightContainerR="auto" tabsPosition='left' paramsUse tabs={
            [
                {
                    label: 'Agente de Marketing',
                    component: <MarketingAgentFormComponent />,
                    disabled: false,
                    icon: <UploadIcon />,
                    visible: true,
                },
            ]
        } refreshContent={false} />
    </div>
  )
}
